<!--产品册-->
<template>
    <div>
        <div class="commodity">
            <!--// 左侧导航内容 -->
            <div class="leftNav">
                <ul>
                    <li class="left-li" v-for="(item, index) in rightData" :key="index" :class="{ typeStyle: index === currentIndex }" @click.stop="onClickNav(index)">
                        <span :class="`leftTit ${index == currentIndex ? 'left-tit-check' : ''}`">{{ item.oneTitle }}</span>
                    </li>
                </ul>
            </div>
            <!--// 右侧商品内容 -->
            <div class="rightContant">
                <ul ref="shopContant">
                    <li class="eventList" v-for="(item, index) in rightData" :key="index">
                        <div class="flex-row">
                            <div class="title-before"></div>
                            <div class="rightTtitle">{{ item.oneTitle }}</div>
                        </div>
                        <div>
                            <div v-for="(oItem, index) in item.apiTwoCatalogueDTOList" :key="index">
                                <!-- <div class="rightTwoTtitle">{{ oItem.twoTitle }}</div> -->
                                <!--2024-05-20 按前端要求进行隐藏-->
                                <ul class="item-list">
                                    <li class="gather" v-for="(sItem, index) in oItem.apiBrochureListDTOS" :key="index">
                                        <div class="flex-row flex-y-center" @click="toDetail(sItem.id)">
                                            <img class='img' :src="sItem.listImg" alt="" />
                                            <div class="right-title">
                                                {{ sItem.title }}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import BScroll from '@better-scroll/core';
    export default {
        name: "productVolume",
        data() {
            return {
                rightData: [], //右侧目录
                scrollY: 0, // 右侧滑动的时候距离顶部的值
                rightSide: [] // 所有右侧分类li的top组成的数组  (列表第一次显示后就不再变化)
            };
        },
        mounted() {
            this.initializeRoll(); //滑动初始化方法
            this.initializeOwn(); //初始化rightSide方法
            this.getRightData();
        },
        //计算属性
        computed: {
            // 计算出当前分类的下标
            currentIndex() {
                const {
                    scrollY,
                    rightSide
                } = this; //拿到每次滑动的值以及每一个分类的下标值
                //findIndex() 方法返回传入一个测试条件（函数）符合条件的数组第一个元素位置
                //获取数组rightSide中每一个下标值并筛选条件返回第一个元素索引位置
                const index = rightSide.findIndex((top, index) => {
                    // scrollY>=当前top && scrollY<下一个top
                    return scrollY >= top && scrollY < rightSide[index + 1];
                });
                // 返回结果
                return index;
            }
        },
        watch: {
            rightData: function () {
                this.$nextTick(() => {
                    this.initializeOwn();
                    this.initializeRoll();
                })
            }
        },
        methods: {
            // 初始化滚动
            initializeRoll() {
                // new一个类的实例，前提必须确保父元素和子元素的内容已经正确渲染了，不然不会生效
                // if(!this.leftScroll){
                //  this.leftScroll =  new BScroll(".leftNav", {
                //     click: true
                // });
                // }else{
                //      this.leftScroll.refresh();//防止二次click
                // }
                // 组件实例上挂属性
                this.foodsScroll = new BScroll(".rightContant", {
                    probeType: 3, // 因为惯性滑动不会触发
                    click: true
                });

                // 给右侧列表绑定scroll监听
                this.foodsScroll.on("scroll", ({
                    x,
                    y
                }) => {
                    //this.scrollY = Math.abs(y);
                    if (Math.abs(y) == this.scrollY) {
                        this.foodsScroll.stop();//到达目的地后，不回弹
                    }
                });
                // 给右侧列表绑定scroll结束的监听
                this.foodsScroll.on("scrollEnd", ({
                    x,
                    y
                }) => {
                    this.scrollY = Math.abs(y);
                });
            },
            // 初始化rightSide
            initializeOwn() {

                // 初始化rightSide
                const rightSide = [];
                let top = 0;
                rightSide.push(top);
                // 找到所有分类下的li
                const lis = this.$refs.shopContant.getElementsByClassName("eventList");
                // slice() 方法返回一个新的数组对象
                Array.prototype.slice.call(lis).forEach(li => {
                    top += (li.clientHeight + 10);
                    rightSide.push(top);
                });

                //更新数据
                this.rightSide = rightSide;
                // console.log(rightSide)
            },
            //左侧点击事件
            onClickNav(index) {
                //拿到目标位置的scrollY，点击左侧导航，右侧列表滑动到对应的位置
                const scrollY = this.rightSide[index];
                // 点击的分类成为当前分类，索引当前选中的导航标题
                this.scrollY = scrollY;
                // 平滑滑动右侧列表
                this.foodsScroll.scrollTo(0, -scrollY, 1000);

            },
            // 获取右边列表数据
            getRightData() {
                request({
                    url: `/brochure/list?type=1`,
                    method: "get",
                })
                    .then((res) => {
                        this.rightData = res.data;

                    }).catch(() => {
                        this.rightData = [];
                    }).finally(() => {
                    });
            },
            //跳转详情界面
            toDetail(id) {
                this.$router.push({ name: "productVolumeDetail", query: { id: id } });
            },
            noReloaded() {
                if (location.href.indexOf("#reloaded") == -1) {
                    location.href = location.href + "#reloaded";
                    window.location.reload();
                }
            },
        }
    };
</script>
<style scoped>
    .commodity {
        /* 最大的盒子样式 */
        display: flex;
        position: fixed;
        top: 0px;
        bottom: 0px;
        width: 100%;
        background: #fff;
        overflow: hidden;
    }

    .leftNav {
        /* 左侧大盒子的整体样式 */
        width: 180px;
        background: rgb(248, 248, 248);
    }

    .left-li {
        margin-top: 20px;
    }

    .typeStyle {
        /* 左侧导航选中的样式 */
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .rightTwoTtitle {
        font-size: 34px;
        font-weight: 700;
        color: #35434c;
        line-height: 48px;
        padding: 0 30px;
        margin-top: 30px;
    }

    .leftTit {
        /* 左侧导航标题默认样式 */
        display: flex;
        height: 100px;
        justify-content: center;
        font-size: 30px;
        align-items: center;
    }

    .left-tit-check {
        font-size: 28px !important;
    }

    .rightContant {
        /* 右侧大盒子的整体样式 */
        flex: 1;
    }

    .eventList {
        border-bottom: 20px solid #f7f7f7;
    }

    .title-before {
        display: inline-div;
        width: 6px;
        height: 26px;
        border-radius: 35px;
        background: #2fd0d5;
        margin: 40px 0 0 5px;
    }

    .rightTtitle {
        font-size: 40px;
        font-weight: 700;
        color: #35434c;
        line-height: 48px;
        margin-top: 30px;
        padding: 0 15px;
    }

    .img {
        width: 120px;
        height: 120px;
        margin-right: 30px;
        border-radius: 50%;
    }

    .gather {
        /* 右侧每一个商品的样式 */
        display: flex;
        margin: 16px;
        align-items: center;
    }

    .distance {
        /* 右侧图片与描述间距 */
        padding-left: 6px;
    }

    .right-title {
        font-size: 30px;
    }

    .saleGood {
        /* 右侧月售好评样式 */
        font-size: 10px;
        color: rgb(147, 153, 159);
        padding: 4px 0px;
    }

    .saleGood span:first-child {
        /* 月售样式 */
        padding-right: 10px;
    }

    .price {
        /* 价格样式 */
        font-weight: bold;
        font-size: 14px;
        color: rgb(255, 94, 121);
    }
</style>
